import {
  INVITATION_OUTCOME_ACCEPTED,
  INVITATION_OUTCOME_ALREADY_ACCEPTED,
  INVITATION_OUTCOME_ALREADY_INVITED,
  INVITATION_OUTCOME_ALREADY_MEMBER,
  INVITATION_OUTCOME_EMAIL_UNVERIFIED,
  INVITATION_OUTCOME_INVALID_LINK,
  INVITATION_OUTCOME_INVITED,
  INVITATION_OUTCOME_REVOKED,
  INVITATION_OUTCOME_WRONG_ACCOUNT,
} from '../invitation.const'
import { InvitationOperationCategory } from '../invitation.interface'

export function classifyInvitationOperation(outcome: string): InvitationOperationCategory {
  switch (outcome) {
    case INVITATION_OUTCOME_ACCEPTED:
    case INVITATION_OUTCOME_ALREADY_ACCEPTED:
      return InvitationOperationCategory.AcceptSuccess
    case INVITATION_OUTCOME_INVITED:
      return InvitationOperationCategory.SendSuccess
    case INVITATION_OUTCOME_ALREADY_INVITED:
      return InvitationOperationCategory.SendInformational
    case INVITATION_OUTCOME_ALREADY_MEMBER:
      return InvitationOperationCategory.SendConflict
    case INVITATION_OUTCOME_WRONG_ACCOUNT:
      return InvitationOperationCategory.IdentityMismatch
    case INVITATION_OUTCOME_EMAIL_UNVERIFIED:
      return InvitationOperationCategory.EmailBlocked
    case INVITATION_OUTCOME_INVALID_LINK:
    case INVITATION_OUTCOME_REVOKED:
      return InvitationOperationCategory.LinkTerminal
    default:
      return InvitationOperationCategory.Unknown
  }
}

export function shouldRefreshStoresAfterAccept(outcome: string): boolean {
  return classifyInvitationOperation(outcome) === InvitationOperationCategory.AcceptSuccess
}
